// src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import Main from "./pages/Main";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InstancePage from "./pages/InstancePage";
import ChatbotWithSettings from "./pages/ChatbotWithSettings";
import ChatbotsList from "./pages/ChatbotList";
import Docs from "./pages/Docs";
import BlankLayout from "./components/layouts/BlankLayout";
import Layout from "./components/layouts/Layout";
import { useEffect } from "react";
import Dashboard from "./pages/Dashboard";
import ForgetPassword from "./pages/ForgetPassword";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";

function App() {
  useEffect(() => {
    if (window.location.pathname === "/") {
      window.location.replace("/login");
    }
  }, []);

  return (
    <Router>
      <Routes>
        {/* Wrap login with BlankLayout */}
        <Route
          path="/login"
          element={
            <BlankLayout>
              <Login />
            </BlankLayout>
          }
        />

        <Route
          path="/forget-password"
          element={
            <BlankLayout>
              <ForgetPassword />
            </BlankLayout>
          }
        />

        <Route
          path="/signup"
          element={
            <BlankLayout>
              <Signup />
            </BlankLayout>
          }
        />

        <Route
          path="/dashboard"
          element={
            <Layout>
              <Dashboard />
            </Layout>
          }
        />

        <Route path="/docs" element={<Docs />} />

        <Route
          path="/main"
          element={
            <Layout>
              <Main />
            </Layout>
          }
        />
        <Route
          path="/profile"
          element={
            <Layout>
              <Profile />
            </Layout>
          }
        />

        <Route
          path="/settings"
          element={
            <Layout>
              <Settings />
            </Layout>
          }
        />

        <Route
          path="/instance/:instanceId"
          element={
            <Layout>
              <InstancePage />
            </Layout>
          }
        />

        {/* Chatbots List for an Instance */}
        <Route
          path="/instance/:instanceId/chatbots"
          element={
            <Layout>
              <ChatbotsList />
            </Layout>
          }
        />

        <Route
          path="/instance/:instanceId/chatbots/new"
          element={
            <Layout>
              <ChatbotWithSettings mode="create" />
            </Layout>
          }
        />

        <Route
          path="/instance/:instanceId/chatbots/:chatbotId"
          element={
            <Layout>
              <ChatbotWithSettings mode="edit" />
            </Layout>
          }
        />
      </Routes>

      {/* Add ToastContainer here - this is what was missing! */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{ zIndex: 9999 }}
      />
    </Router>
  );
}

export default App;
